import React from 'react';

interface CircularProgressBarProps {
    percentage: number;
    size?: number;
    strokeWidth?: number;
    circleColor?: string;
    progressColor?: string;
    textColor?: string;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
    percentage,
    size = 100,
    strokeWidth = 10,
    circleColor = '#e0e0e0',
    progressColor = '#4CAF50',
    textColor = '#000000',
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {/* Background Circle */}
            <circle stroke={circleColor} fill="transparent" strokeWidth={strokeWidth} r={radius} cx={size / 2} cy={size / 2} />

            {/* Progress Circle */}
            <circle stroke={progressColor} fill="transparent" strokeWidth={strokeWidth} r={radius} cx={size / 2}
                cy={size / 2} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} transform={`rotate(-90 ${size / 2} ${size / 2})`} style={{ transition: 'stroke-dashoffset 0.35s ease-out' }}
            />

            {/* Percentage Text */}
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fill={textColor} fontSize={`${size / 4}px`} >
                {`${Math.round(percentage)}%`}
            </text>
        </svg>
    );
};

export default CircularProgressBar;